class VideoModal {
    init() {
        document.querySelectorAll(".modal-link").forEach(link => {
            link.addEventListener("click", this.openModal.bind(this));
        });

        document.addEventListener("keydown", this.handleKeyDown.bind(this));
        document.addEventListener("click", this.handleOutsideClick.bind(this));

        document.querySelectorAll(".close-button").forEach(button => {
            button.addEventListener("click", (e) => {
                const modal = e.target.closest(".modal-outer");
                this.closeModal(modal.id);
            });
        });
    }

    openModal(event) {        
        const link = event.currentTarget;
        const modalId = link.getAttribute("data-video-id");
        const videoLink = link.getAttribute("data-video-link");
        const videoTitle = link.getAttribute("data-video-title");
        const transcriptLink = link.getAttribute("data-video-transcript");        

        const modal = document.getElementById(modalId);
        if (modal) {
            modal.style.display = "block";

            // Set video and transcript data
            const embedPlayer = modal.querySelector(".embed-player");
            embedPlayer.setAttribute("src", videoLink);
            embedPlayer.setAttribute("title", videoTitle);

            const transcriptButton = modal.querySelector(".video-transcript .btn");
            if (transcriptButton) transcriptButton.setAttribute("href", transcriptLink);

            // Set autofocus attribute on modal-container
            const modalContainer = modal.querySelector(".modal-container");
            if (modalContainer) {
                modalContainer.setAttribute("autofocus", "true");
                modalContainer.focus();
            }

            // Trap focus within the modal
            this.trapFocus(modal);
        }
    }

    closeModal(modalId) {
        const modal = document.getElementById(modalId);
        if (modal) {
            const iframe = modal.querySelector("iframe");
            iframe.setAttribute("src", ""); // Stop the video
            modal.style.display = "none"; // Hide the modal

            // Remove autofocus attribute
            const modalContainer = modal.querySelector(".modal-container");
            if (modalContainer) {
                modalContainer.removeAttribute("autofocus");
            }
        }
    }

    handleKeyDown(event) {
        if (event.key === "Escape") {
            document.querySelectorAll(".modal-outer").forEach(modal => {
                if (modal.style.display === "block") {
                    this.closeModal(modal.id);
                }
            });
        }
    }

    handleOutsideClick(event) {
        const modal = event.target.closest(".modal-outer");
        if (modal) {
            const modalContainer = modal.querySelector(".modal-container");
            if (!modalContainer.contains(event.target)) {
                this.closeModal(modal.id);
            }
        }
    }

    trapFocus(modal) {
        const focusableElements = modal.querySelectorAll(
            "iframe, button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (firstElement) firstElement.focus();

        modal.addEventListener("keydown", (event) => {
            if (event.key === "Tab") {
                if (event.shiftKey && document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                } else if (!event.shiftKey && document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        });
    }
}

export default VideoModal;
